import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import {ref} from "vue";
import {useSettingsStore} from "@/store/settings";
import {useUserSettings} from "@/composables/user-settings";
import http from "@/tools/http-client";

export const useClubSignUpStore
    = defineStore('clubSignUpStore', () => {

    const clubSignUpUrl = environment.appConfig.baseApiUrl + "club-signup";
    const crud = useCrudStore(clubSignUpUrl);
    const settingsStore = useSettingsStore();

    const firstName = ref(null)
    const lastName = ref(null)
    const email = ref(null)
    const phone = ref(null)
    const city = ref(null)
    const info = ref(null)

    function fillFromUserSettings() {
        const userSettings = useUserSettings();
        console.log('User settings', JSON.stringify(userSettings));
        firstName.value = userSettings.first_name;
        lastName.value = userSettings.last_name;
        email.value = userSettings.email;
        phone.value = userSettings.phone;
        city.value = userSettings.city;
        info.value = userSettings.info;
    }

    async function clubSignUp() {
        console.log("clubSignUp invoked", firstName.value, lastName.value);
        crud.startLoading();
        try {
            const params = {
                first_name: firstName.value,
                last_name: lastName.value,
                email: email.value,
                phone: phone.value,
                city: city.value,
                info: info.value,
            };
            const resp = await http.post(crud.endpoint.value, params);
            console.log('Success', JSON.stringify(resp.data))
            crud.clearLoading();
            if (resp.data.status === 'success') {
                await settingsStore.loadSetting();
                return;
            }
            crud.setError(resp.data.message);
        } catch (e) {
            crud.setError(e);
        }
    }

    return {
        ...crud,
        firstName,
        lastName,
        email,
        phone,
        city,
        info,
        fillFromUserSettings,
        clubSignUp
    }
});
